import { render } from "./UpdateEmailTwoFA.vue?vue&type=template&id=05beebbf&ts=true"
import script from "./UpdateEmailTwoFA.vue?vue&type=script&lang=ts"
export * from "./UpdateEmailTwoFA.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__